module.exports = __webpack_public_path__ + "img/7216252.jpg";